import { http } from '../api/http';

export type AdminDocumentType = {
  id: number;
  code: string;
  label: string;
  is_active: boolean;
  sort_order: number;
};

export const AdminDocumentTypesService = {
  list() {
    return http<{ ok: boolean; data: AdminDocumentType[] }>('/admin/project-document-types');
  },

  create(payload: { code: string; label: string; is_active?: boolean; sort_order?: number }) {
    return http<{ ok: boolean; data: AdminDocumentType }>('/admin/project-document-types', {
      method: 'POST',
      body: payload
    });
  },

  update(id: number | string, payload: { label?: string; is_active?: boolean; sort_order?: number }) {
    return http<{ ok: boolean; data: AdminDocumentType }>(`/admin/project-document-types/${id}`, {
      method: 'PATCH',
      body: payload
    });
  }
};
